import { Box, Tab, Tabs, useMediaQuery, useTheme } from "@mui/material";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import CaseStudyOverview from "./caseStudyOverview";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {
                value === index && (
                    <Box sx={{ py: 1 }}>
                        {children}
                    </Box>
                )
            }
        </div>
    );
}

const CaseStudyOverviewLayout = ({data}) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    const [value, setValue] = useState(0);
    
    const handleChange = useCallback((event, newValue) => {
        setValue(newValue);
    }, []);
    
    return (
        <>
            <Box
                className="sectionSpacing"
            >
                <Box
                    sx={{
                        width: '100%',
                        pb: {xs: 3, md: 5}
                    }}
                >
                    <Tabs 
                        value={value} 
                        onChange={handleChange}
                        centered={!isMobile}
                        variant={isMobile ? "scrollable" : "fullWidth"}
                        scrollButtons={isMobile ? "auto" : false}
                    >
                        <Tab 
                            label={t('caseStudies.overviews.problem')} 
                            sx={{
                                textTransform: 'none',
                                fontSize: {xs: 12, md: 14, lg: 16},
                                lineHeight: 1.5,
                                '&.Mui-selected': {
                                    color: theme.palette.text.primary
                                }
                            }}
                        />

                        <Tab 
                            label={t('caseStudies.overviews.approach')} 
                            sx={{
                                textTransform: 'none',
                                fontSize: {xs: 12, md: 14, lg: 16},
                                lineHeight: 1.5,
                                '&.Mui-selected': {
                                    color: theme.palette.text.primary
                                }
                            }}
                        />

                        <Tab 
                            label={t('caseStudies.overviews.solution')} 
                            sx={{
                                textTransform: 'none',
                                fontSize: {xs: 12, md: 14, lg: 16},
                                lineHeight: 1.5,
                                '&.Mui-selected': {
                                    color: theme.palette.text.primary
                                }
                            }}
                        />
                    </Tabs>
                </Box>

                <TabPanel value={value} index={0}>
                    <CaseStudyOverview 
                        title={t('caseStudies.overviews.problem')} 
                        data={data.problem}
                        sx={{
                            px: {xs: 1, md: 5}
                        }}
                    />
                </TabPanel>
                
                <TabPanel value={value} index={1}>
                    <CaseStudyOverview 
                        title={t('caseStudies.overviews.approach')} 
                        data={data.approach}
                        sx={{
                            px: {xs: 1, md: 5}
                        }}
                    />
                </TabPanel>
                
                <TabPanel value={value} index={2}>
                    <CaseStudyOverview 
                        title={t('caseStudies.overviews.solution')} 
                        data={data.solution}
                        sx={{
                            px: {xs: 1, md: 5}
                        }}
                    />
                </TabPanel>
            </Box>
        </>
    );
}

export default CaseStudyOverviewLayout;